import { DeleteRequest, GetRequest, PostRequest } from "../../plugins/https";
import { deleteContact, getContact, setContact } from "./action";
import { DELETE_CONTACT, GET_CONTACT, SET_CONTACT } from "./actionType";

export const addContact = (Contact) => async (dispatch) => {
  try {
    const res = await PostRequest("/contact", Contact);
    dispatch(setContact(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const getContactData = async (dispatch) => {
  try {
    const res = await GetRequest("/contact");
    dispatch(getContact(res.data.data));
  } catch (error) {
    console.error("Error getting contact:", error);
  }
};

export const deleteContactData = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/contact/${id}`);
    dispatch(deleteContact(id));
  } catch (error) {
    console.error("Error in deleting contacta: ", error);
  }
};

const initialState = {
  contact: "",
  contactData: [],
};

export const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTACT:
      return {
        ...state, // Copy the previous state
        contact: action.payload, // Update the 'contact' field with the new contact
      };
    case GET_CONTACT:
      return {
        ...state, // Copy the previous state
        contactData:
          action.payload && action.payload.data
            ? action.payload.data
            : action.payload, // normalize to inner data array when present
      };
    case DELETE_CONTACT:
      return {
        ...state,
        contactData: state.contactData.filter(
          (item) => item.id !== action.payload,
        ),
      };
    default:
      return state;
  }
};
